import PropTypes from 'prop-types';
import {View} from '@ab/components';
import MainModel from '../models/main.m';
import mainTpl from '../templates/main';

export default class extends View {
    uiStates = {
        ...this.uiStates,
        WARNING: 'warning',
        EXPIRE: 'expire',
    };

    templates = {
        [this.uiStates.INITIAL]: mainTpl,
        [this.uiStates.INTERACTIVE]: mainTpl,
        [this.uiStates.STANDBY]: mainTpl,
        [this.uiStates.ERROR]: mainTpl,
        [this.uiStates.WARNING]: mainTpl,
        [this.uiStates.EXPIRE]: mainTpl,
    };

    constructor() {
        super();

        this.state = {
            ui: this.uiStates.INITIAL,
        };

        this.model = new MainModel();

        return this;
    }

    componentDidMount() {
        super.componentDidMount();
        this.start();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.stop();
        return this;
    }

    /**
     * start session
     */
    start() {
        let model = this.getModel();
        model.set('expire', new Date().getTime() + this.props.ttl);

        this.timerInterval = setInterval(() => {
            if (this.isGoingToExpire()) {
                this.showWarning();
            }

            if (this.isExpired()) {
                this.showExpire();
            }
        }, 1000);
    }

    stop() {
        clearInterval(this.timerInterval);
        return this;
    }

    /**
     * show warning popup
     * @return {Promise}
     */
    showWarning() {
        let model = this.getModel();

        if (!model.get('warningShown')) {
            model.set('warningShown', true);

            return this.setState({ui: this.uiStates.WARNING});
        } else {
            return Promise.resolve();
        }
    }

    /**
     * show expire popup
     * @return {Promise}
     */
    showExpire = () => {
        this.destroySession();

        return this.setState({ui: this.uiStates.EXPIRE});
    };

    abortSession = () => {
        this.destroySession();
        this.home();
    };

    destroySession = () => {

        clearInterval(this.timerInterval);
        window.sessionStorage && window.sessionStorage.clear();
        this.stop();

        return this;
    };

    /**
     * reset session time
     * @return {Promise}
     */
    reset = () => {
        // Refresh API removed - no longer updating session on server
        return Promise.resolve();
    };

    home = () => {
        window.location.href = '/';
    };

    isExpired() {
        let model = this.getModel(),
            time = new Date().getTime();

        return model.get('expire') - time < 0;
    }

    isGoingToExpire() {
        let model = this.getModel(),
            time = new Date().getTime();

        return model.get('expire') - time <= this.props.warningTime;
    }

    /**
     * слушает активность пользователя
     * Removed refresh functionality as API is deprecated
     * @private
     */
    _handleUserActivity = () => {
        // User activity tracking disabled - refresh API no longer available
    };

    static propTypes = {
        ttl: PropTypes.number,
        warningTime: PropTypes.number,
    };

    static defaultProps = {
        // 19 min
        ttl: 1140000,
        // time before end of session to show warning
        // 30 sec
        warningTime: 30000,
    };

    static displayName = 'Session';
}
